import React from "react";
import s from "./next-class-card.module.scss";
import { IconCalendarTime, IconSchool } from "@tabler/icons-react";
import classNames from "classnames";
import { Button } from "@shared/ui/button/button";
import { TZDate } from "@date-fns/tz";
import { queryClient } from "@shared/api/query-client";
import { getCDNPath } from "@utils/lib/getCDNpath";
import { addMinutes, format, isToday as isTodayFn } from "date-fns";
import ru from "date-fns/locale/ru";
import { TextWithEmoji } from "@shared/ui/text-with-emoji/text-with-emoji";

export const NextClassCard = ({
  id,
  teacher,
  student,
  starts_at,
  role = 'student',
  instrument,
  className,
  compact
}) => {
  const {data: profile} = queryClient.getQueryData(['profile'])
		
	const date = new TZDate(starts_at, profile?.timezone)
	const dateFormat = format(date, 'd MMMM', {locale: ru})
	const timeStart = format(date, 'HH:mm')
	const timeEnd = format(addMinutes(date, 50), 'HH:mm', {locale: ru})
  const isToday = isTodayFn(date)

  return (
    <div className={classNames(className, s.nextClassCard, isToday ? s.today : '', compact ? s.compact : '')}>
			{!compact && <img className={s.mascot} src={getCDNPath("images/character_clock.webp")} alt="" />}
			<h3 className={s.title}>Следующее занятие</h3>
			<div className={classNames(s.info, s[role], compact ? s.compactInfo : '')}>
				<div className={classNames(s.tag, s.date, isToday ? s.today : '')}>
							{isToday
								? "Сегодня, " + dateFormat
								: dateFormat}
				</div>
				<div className={classNames(s.tag, s.time)}>	
					<IconCalendarTime size={14} />
					<span>
						{timeStart}-{timeEnd}
					</span>
				</div>
				{!compact && (
					<>
						<div className={classNames(s.tag ,s.instrument)}><TextWithEmoji text={instrument?.name}/></div>
						<div className={classNames(s.tag, s.teacher)}>
							<IconSchool size={14} />
							{role === "student" ? teacher?.name : student?.name}
						</div>
					</>
				)}
			</div>
			<Button
			className={classNames(s.button, compact ? s.compactButton : '')}
				label={"Подключиться"}
				size={compact || "small"}
				to={"/appointment/" + id}
			/>
    </div>
  );
};
